// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(portal)/_layout.tsx": { enumerable: true, get() { return require("/app/app/(portal)/_layout.tsx"); } },
  "./(portal)/absences.tsx": { enumerable: true, get() { return require("/app/app/(portal)/absences.tsx"); } },
  "./(portal)/calendar.tsx": { enumerable: true, get() { return require("/app/app/(portal)/calendar.tsx"); } },
  "./(portal)/communities.tsx": { enumerable: true, get() { return require("/app/app/(portal)/communities.tsx"); } },
  "./(portal)/edo/requests/[id].tsx": { enumerable: true, get() { return require("/app/app/(portal)/edo/requests/[id].tsx"); } },
  "./(portal)/edo/requests/index.tsx": { enumerable: true, get() { return require("/app/app/(portal)/edo/requests/index.tsx"); } },
  "./(portal)/help.tsx": { enumerable: true, get() { return require("/app/app/(portal)/help.tsx"); } },
  "./(portal)/home.tsx": { enumerable: true, get() { return require("/app/app/(portal)/home.tsx"); } },
  "./(portal)/kb.tsx": { enumerable: true, get() { return require("/app/app/(portal)/kb.tsx"); } },
  "./(portal)/learning.tsx": { enumerable: true, get() { return require("/app/app/(portal)/learning.tsx"); } },
  "./(portal)/more.tsx": { enumerable: true, get() { return require("/app/app/(portal)/more.tsx"); } },
  "./(portal)/news.tsx": { enumerable: true, get() { return require("/app/app/(portal)/news.tsx"); } },
  "./(portal)/news/[id].tsx": { enumerable: true, get() { return require("/app/app/(portal)/news/[id].tsx"); } },
  "./(portal)/org.tsx": { enumerable: true, get() { return require("/app/app/(portal)/org.tsx"); } },
  "./(portal)/people.tsx": { enumerable: true, get() { return require("/app/app/(portal)/people.tsx"); } },
  "./(portal)/post/[id].tsx": { enumerable: true, get() { return require("/app/app/(portal)/post/[id].tsx"); } },
  "./(portal)/processes/[id].tsx": { enumerable: true, get() { return require("/app/app/(portal)/processes/[id].tsx"); } },
  "./(portal)/processes/index.tsx": { enumerable: true, get() { return require("/app/app/(portal)/processes/index.tsx"); } },
  "./(portal)/processes/new/[form].tsx": { enumerable: true, get() { return require("/app/app/(portal)/processes/new/[form].tsx"); } },
  "./(portal)/processes/new/index.tsx": { enumerable: true, get() { return require("/app/app/(portal)/processes/new/index.tsx"); } },
  "./(portal)/processes/recruitment.tsx": { enumerable: true, get() { return require("/app/app/(portal)/processes/recruitment.tsx"); } },
  "./(portal)/profile.tsx": { enumerable: true, get() { return require("/app/app/(portal)/profile.tsx"); } },
  "./(portal)/settings.tsx": { enumerable: true, get() { return require("/app/app/(portal)/settings.tsx"); } },
  "./(portal)/signing.tsx": { enumerable: true, get() { return require("/app/app/(portal)/signing.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/app/app/_layout.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/app/app/index.tsx"); } },
  "./login.tsx": { enumerable: true, get() { return require("/app/app/login.tsx"); } },
  "./reset-password.tsx": { enumerable: true, get() { return require("/app/app/reset-password.tsx"); } },
  "./s/[token].tsx": { enumerable: true, get() { return require("/app/app/s/[token].tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;